export enum ConditionTypes {
  GLOBAL = 0,
  SELECTED_PRODUCTS = 1
}

export enum ConditionApplies {
  ALL = "all",
  THE_CHEAPEST = "the_cheapest",
  THE_MOST_EXPENSIVE = "the_most_expensive"
}

export enum AffiliatePayoutDestinationCode {
  WALLET = "wallet",
  OFFLINE = "offline",
  PAYPAL = "paypal"
}

export enum OverrideCommissionsTypes {
  OVERWRITE = 1,
  RECALCULATE_AGAIN = 2
}
